<template>
<v-main style="background-color: white;">
  <v-card style="background-color:#707070; position:fixed; top:0px; width:100%; z-index:10;" class="pa-1 d-flex align-center" tile>
    <v-icon color="white">mdi-bell</v-icon>
    <p style="color:white" class="my-0">全体通知</p>
    <v-spacer></v-spacer>
    <v-chip color="#BA0009" dark class="ml-2">新着<span v-text="notify.length"></span>件</v-chip>
    <v-icon color="white" large @click="$emit('close',true)">mdi-close</v-icon>    
  </v-card>
  <v-list class="py-0 mt-10" style="background-color:white;">
    <div v-if="notify.length>0" style="background-color:white">
      <v-expansion-panels accordion>
        <v-expansion-panel v-for="item in notify" :key="item.sort">
          <v-expansion-panel-header three-line class="pa-1 pl-2">
            <v-list-item-title class="d-flex" style="max-width: 240px; color:#2B2B2B">
              <span style="white-space: pre-wrap;">{{ item.title }}</span>
            </v-list-item-title>
            <v-list-item-content class="ml-auto" style="text-align: right;">
              <div class="d-flex flex-column">
                <v-chip :color="item.isImportant ? '#BA0009' : '#399942'" dark class="ml-auto">
                  <span>{{ item.tag }}</span>
                </v-chip>
                
                <div class="mt-2">
                  <p v-if="item.createdAt || item.created" style="margin: 0;">
                    {{ (item.createdAt || item.created).toDate().getMonth() + 1 }}/{{ (item.createdAt || item.created).toDate().getDate() }}
                  </p>
                </div>
              </div>
            </v-list-item-content>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div style="color:#2B2B2B" class="my-2" v-html="item.content"></div>
            <v-list-item-subtitle class="d-flex align-center">
              <v-btn v-if="enabledCheckNotify(item.type)" @click="checkNotify(item)" text style="background-color:#dcdcdc; font-size:10px;">確認する</v-btn>
            </v-list-item-subtitle>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else style="background-color:white">
      <p class="text-center py-4 mb-0">通知はありません。</p>
    </div>
  </v-list>
</v-main>
</template>

<script>
import firebase from 'firebase'

export default {
  props: {
    onlyImportant: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data: () => ({
    uid: "",
    currentName: "",
    db: null,
    now: "",
  }),
  computed: {
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    config(){
      return this.$store.state.config
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    notify(){
      return this.onlyImportant ? this.$store.state.notifys.filter(item=>item.isImportant&&!item.read) : this.$store.state.notifys
    },
  },
  created() {
    this.db = firebase.firestore() // dbインスタンスを初期化
  },
  mounted(){
    this.$store.dispatch('setNotifyRead')
  },
  methods: {
    closeAuthModal() {
      this.authModal = false
    },
    closeProfile() {
      this.profileModal = false;
    },
    checkNotify(item){
      const type = item.type;
      if(type==0) this.$router.push("/sp_home?page=news")
      if(type==2) this.$router.push("/sp_home?page=offline")
      if(type==3||type=="l1") this.$router.push(`/sp/${item.lidid}/content`)
      if(type==8 || type==9) this.$router.push(`/sp/${item.lidid}/idea`)
      // if(type==27 || type==30) this.$emit(`openModal`, index)
      // if(type==90) this.$emit('openModal', index)
      this.$emit('close',true)
    },
    enabledCheckNotify(type) {
      // checkNotifyの条件を満たしているかどうか
      return type==0 || type==2 || type==3 || type=="l1" || type==8 || type==9
    }
  }
}
</script>
<style scoped>
</style>